export enum TopNavBarButtonID {
	Hamburger = 'Hamburger',
	Person = 'Person',
	Kost = 'Kost',
	LabelISS = 'LabelISS',
	AppVersionInfo = 'AppVersionInfo',
	Settings = 'Settings',
}

export enum TopNavBarButtonDomIDs {
	Hamburger = 'TopNavBarButtonHamburger',
	Person = 'TopNavBarButtonPerson',
	Kost = 'TopNavBarButtonKost',
	AppVersionInfo = 'TopNavBarButtonAppVersionInfo',
	LabelISS = "TopNavBarLabelISS",
	Settings = 'TopNavBarButtonSettings',
}
